module.exports = __webpack_public_path__ + "static/media/07_tn.310ad78f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/07_tn.jpg
// module id = 496
// module chunks = 0